import { render, staticRenderFns } from "./giftcard-topping-popup.vue?vue&type=template&id=61f3402c&scoped=true&"
import script from "./giftcard-topping-popup.vue?vue&type=script&lang=js&"
export * from "./giftcard-topping-popup.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-topping-popup.vue?vue&type=style&index=0&id=61f3402c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3402c",
  null
  
)

export default component.exports